import {remCalc} from '../../_utils'

export default {
    baseStyle: () => ({
        container: {
            boxSizing: 'border-box',
            position: 'relative',
            alignItems: 'flex-start',
            minWidth: remCalc(310),
            width: '100%',
            height: '100%',
            padding: 0,
            gap: 0,
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.highlight',
            boxShadow: `0 0 0 ${remCalc(
                1,
            )} var(--chakra-colors-border-neutral-highlight) inset, 0 ${remCalc(1)} ${remCalc(
                2,
            )} 0 var(--chakra-shadows-neutral-xs), 0 0 0 ${remCalc(
                1,
            )} var(--chakra-shadows-neutral-xs)`,
            borderRadius: 'large-1',
        },
        bottomContainer: {
            padding: 'xsmall-1.base',
            width: '100%',
            flexDir: 'column',
            pading: 'xsmall.lg',
            alignItems: 'flex-start',
            gap: 'xsmall.lg',
        },
        headerRow: {
            width: '100%',
            height: remCalc(22),
            padding: 0,
            gap: 0,
            alignSelf: 'stretch',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        subheaderRow: {
            gap: 'xsmall.base',
            alignItems: 'center',
            width: '100%',
            height: remCalc(22),
        },
        body: {
            width: '100%',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: 'xxsmall-1.base',
            alignSelf: 'stretch',
        },
        colorSwatchContainer: {
            flexDir: 'column',
            alignItems: 'flex-start',
            boxShadow: `0 0 0 ${remCalc(
                1,
            )} var(--chakra-colors-border-neutral-highlight) inset, 0 ${remCalc(1)} ${remCalc(
                2,
            )} 0 var(--chakra-shadows-neutral-xs), 0 0 0 ${remCalc(
                1,
            )} var(--chakra-shadows-neutral-xs)`,
            borderRadius: 'full',
        },
        keyFeaturesContainer: {
            width: '100%',
            flexWrap: 'wrap',
            // reserve space for two lines so the tile height stays consistent even without key features
            minHeight: remCalc(40),
        },
        keyFeature: {
            gap: {
                base: 'xxsmall-1.base',
                sm: 'xxsmall-1.base',
                md: 'xxsmall-1.lg',
                lg: 'xxsmall-1.lg',
            },
            flexWrap: 'wrap',
            flex: '1 1 auto',
            minWidth: 0,
        },
        footerRow: {
            width: '100%',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            gap: 'xxsmall-1.base',
        },
        favIcon: {
            position: 'absolute',
            variant: 'unstyled',
            top: remCalc(16),
            right: remCalc(16),
            boxSize: 'iconsSize.medium',
            minWidth: 'auto',
        },
        favSvg: {
            boxSize: 'iconsSize.medium',
            color: 'background.dark',
        },
        favSvgSolid: {
            boxSize: 'iconsSize.medium',
            color: 'background.alternative',
        },
        stockLabelContainer: {
            marginBottom: remCalc(16),
        },
        category: {
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
            fontWeight: 'bold',
            marginBottom: remCalc(16),
            textTransform: 'uppercase',
        },
        title: {
            textStyle: 'body-xxlarge',
            fontFamily: 'heading',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
            noOfLines: 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        sku: {
            textStyle: 'body-small',
            color: 'text.secondary',
            fontWeight: 'bold',
        },
        imageWrapper: {
            position: 'relative',
            marginBottom: {base: remCalc(30), lg: remCalc(24)},
        },
        titlePriceWrapper: {
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: remCalc(20),
            gap: {
                base: remCalc(52),
                md: remCalc(27),
                lg: remCalc(24),
            },
        },
        titleWrapper: {
            alignItems: 'start',
            textAlign: 'left',
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(16),
        },
        priceWrapper: {
            width: '100%',
            display: 'flex',
        },
        listPrice: {
            textStyle: 'body-small',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        image: {
            ratio: 1,
        },
        imageOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'background.image',
        },
        imageLabelsContainer: {
            gap: 'xxxsmall.base',
            maxW: '100%',
            flexWrap: 'wrap',
        },
        imageThumbnailOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            my: remCalc(10),
            _hover: {
                backgroundColor: 'background.image',
            },
        },
        badgeGroup: {
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            position: 'absolute',
            top: 0,
            left: 0,
            padding: 'xxsmall-1.base',
            maxWidth: '100%',
            flexWrap: 'nowrap',
        },
        reviewCompareWrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            borderRadius: 'large-1',
            overflow: 'hidden',
            backgroundColor: 'background.default',
            boxShadow: `0 0 0 ${remCalc(
                1,
            )} var(--chakra-colors-border-neutral-highlight) inset, 0 ${remCalc(1)} ${remCalc(
                2,
            )} 0 var(--chakra-shadows-neutral-xs), 0 0 0 ${remCalc(
                1,
            )} var(--chakra-shadows-neutral-xs)`,
        },
        swatchThumbnailWrapper: {
            _hover: {
                borderBottom: 'small',
                borderStyle: 'solid',
            },
        },
        swatchThumbnail: {
            width: remCalc(48),
            height: remCalc(48),
        },
        swatchContainer: {
            marginBottom: {base: remCalc(10), lg: remCalc(4)},
        },
        variantsLabel: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        divider: {
            marginBottom: remCalc(24),
        },
        featureList: {
            textStyle: 'body-small',
            marginBottom: remCalc(24),
        },
        featureListElement: {
            //  mt: remCalc(8),
            textStyle: 'body-small',
            fontWeight: 'regular',
            color: 'foreground.neutral.default',
        },
        buttonGroup: {
            display: 'grid',
            width: '100%',
            gap: {base: remCalc(8), lg: remCalc(16)},
        },
        reviews: {
            //paddingTop: 'xxxsmall-1.base',
            backgroundColor: 'background.default',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.neutral.highlight',
            borderRadius: 'large-1',
            overflow: 'hidden',
            alignItems: 'center',
            justifyContent: 'center',
        },
        compareButtonActive: {
            color: 'foreground.neutral.inverse',
            backgroundColor: 'background.neutral.dark',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            boxShadow: `inset 0 0 0 1px color-mix(var(--chakra-colors-background-neutral-dark), white 40%)`,
            _hover: {
                backgroundColor: 'background.neutral.dark',
            },
        },
    }),
    variants: {
        transparent: {
            imageOverlay: {
                backgroundColor: 'unset',
            },
            imageWrapper: {
                marginBottom: {base: remCalc(8), lg: remCalc(16)},
                borderRadius: remCalc(4),
                overflow: 'hidden',
            },
            badgeGroup: {
                position: 'absolute',
                bottom: remCalc(17),
                left: remCalc(21),
            },
        },
        compact: {
            container: {
                paddingBottom: remCalc(16),
            },
            badgeGroup: {
                position: 'relative',
                display: 'grid',
                width: '100%',
                gap: remCalc(5),
                paddingTop: remCalc(18),
            },
            stockLabelContainer: {
                marginBottom: remCalc(18),
            },
            titleWrapper: {
                gap: remCalc(18),
            },
            titlePriceWrapper: {
                display: 'flex',
                gap: remCalc(18),
                marginBottom: remCalc(18),
            },
            reviewCompareWrapper: {
                display: 'grid',
                justifyItems: 'center',
                alignItems: 'center',
                gap: remCalc(24),
                paddingBottom: remCalc(18),
            },
            compare: {
                marginRight: 'auto',
            },
            energyLabel: {
                // marginBottom: remCalc(18),
            },
            priceWrapper: {
                alignItems: 'start',
                textAlign: 'left',
                gap: 'xxsmall-1.base',
            },
            imageWrapper: {
                position: 'relative',
                display: 'grid',
                marginBottom: remCalc(18),
            },
            image: {
                ratio: 1,
            },
            variantsLabel: {
                marginBottom: remCalc(18),
            },
            divider: {
                marginBottom: remCalc(18),
            },
            category: {
                marginBottom: remCalc(18),
            },
        },
        bundle: {
            badgeGroup: {
                display: 'none',
            },
            image: {
                ratio: {base: 0.895, lg: 1.486},
                h: '100%',
            },
            firstBundleImage: {
                ratio: {base: 0.895, lg: 1.069},
                h: '100%',
            },
            imageOverlay: {
                backgroundColor: 'unset',
            },
            imageWrapper: {
                position: 'relative',
                marginBottom: 'unset',
                w: {base: remCalc(85), lg: '100%'},
                h: {base: remCalc(95), lg: '100%'},
                alignSelf: 'center',
                alignContent: 'center',
            },
        },
        freeItemPromo: {
            imageWrapper: {
                width: '100%',
            },
        },
    },
    parts: [
        'container',
        'imageWrapper',
        'image',
        'imageOverlay',
        'price',
        'reviewCompareWrapper',
        'title',
        'rating',
        'energyLabel',
        'sku',
        'category',
        'stockLabelContainer',
        'variations',
        'badgeGroup',
        'swatchContainer',
        'link',
        'compare',
        'divider',
        'variantsLabel',
        'titlePriceWrapper',
        'collapsableSection',
        'titleWrapper',
        'priceWrapper',
        'bodyWrapper',
        'hovered',
        'imageContainer',
        'firstBundleImage',
    ],
}
